import React from 'react';
import LinearCTAButton from 'src/components/LinearCTAButton';
import styles from './SectionPayLater.module.scss';
import WhatPaidy from './WhatPaidy';


const TITLE = (
  <>
    <strong>あと払いペイディ</strong>とは
  </>
);
const DESCRIPTION =
  'AmazonやQoo10のほか、スマホだけで今すぐお買い物ができるあと払いサービスです。お支払いは翌月27日までならいつでもOK。';

export default function SectionPayLater({
  title = TITLE,
  description = DESCRIPTION,
  id,
  downloadLink,
}) {
  return (
    <section className={styles.section} id={id}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <div className={styles.container}>
        <WhatPaidy />
      </div>
       {downloadLink && <LinearCTAButton
        text={`今すぐアプリをダウンロード`}
        to={downloadLink}
        isExternal
        className={styles.btn}
      />}
    </section>
  );
}
